/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
    | T
    | {
          [P in keyof T]?: P extends ' $fragmentName' | '__typename'
              ? T[P]
              : never
      }

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type LanguagePickerQueryVariables = Exact<{ [key: string]: never }>

export type LanguagePickerQuery = {
    site: {
        __typename: 'Site'
        guid: string
        language: string
        languageOptions: Array<{
            __typename: 'Option'
            value: string
        } | null> | null
    } | null
    viewer: { __typename: 'Viewer'; guid: string; language: string } | null
}

export const LanguagePickerDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'LanguagePicker' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'site' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'guid' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'language' },
                                },
                                {
                                    kind: 'Field',
                                    name: {
                                        kind: 'Name',
                                        value: 'languageOptions',
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'value',
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'viewer' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'guid' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'language' },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<LanguagePickerQuery, LanguagePickerQueryVariables>
